import React from "react";
import { ArrowTopIcon, MoneyIcon } from "../SvgIcons/SvgIcons";
import ChatIcon from "../../../imgs/chatIcon2.svg"
import Dots from "../../../imgs/dots.svg"
import departmentIcon from "../../../imgs/departmenticon.svg";
import { useHistory } from "react-router-dom";

const IntroCard = ({intro}) => {
  const history = useHistory();
  const {
    introPerson: {firstName, lastName},
    bountyId: {demandPrice, reason, title, company},
  } = intro;

  const handleSubmit = () => {
    history.push({
      pathname: '/introdetails',
      state: {intro},
    });
  };

  return (
    <div className="bounty-card-wrapper">
      <div className="feed-card-wrapper">
        <div>
          <div className="row m-0 justify-content-between">
            <h2 className="heading">
              <img src={departmentIcon} alt="logo" />
              {firstName} {lastName}
            </h2>
            <h2 className="small-heading">${demandPrice}</h2>
          </div>
          <p className="mt-2">
            {title} at The {company}
          </p>
        </div>
        <span>For {reason}</span>
      </div>
      {intro?.status === 'accepted' ? (
        <button className="btn-style" onClick={() => history.push('/chat')}>
          Intro accepted
          <div className="sty">
            <span className=" style mr-5">
              <img src={ChatIcon} alt="" /> Arrange Intros
            </span>
            <img src={Dots} alt="" />
          </div>
        </button>
      ) : intro?.status === 'completed' ? (
        <button className="btn-style" onClick={handleSubmit}>
         <span className="money-icon"><MoneyIcon />
        You got the bounty</span>
          <div className="sty">
            <ArrowTopIcon />
          </div>
        </button>
      ) : intro?.status === 'closed' ? (
        <button className="btn-style">
          Bounty Closed.
          <div className="sty">
            <img src={Dots} alt="" />
          </div>
        </button>
      ) : intro?.status === 'cancelled' ? (
        <button className="btn-style">
          Intro has been cancelled.
          <div className="sty">
            <img src={Dots} alt="" />
          </div>
        </button>
      ) : (
        <button className="btn-style">
          Awaiting Decision
          <div className="sty">
            <img src={Dots} alt="" />
          </div>
        </button>
      )}
    </div>
  );
};

export default IntroCard;
